import { ApiConfirmUserFromMap } from "./api-confirm-user.from-map";

export class ApiConfirmUserFromMapper {
  fromMap(map: ApiConfirmUserFromMap): string {
    return map.password;
  }
}
